(() => {
  const addBtn   = document.querySelector('[data-add-to-cart]');
  const toolbar  = document.querySelector('[data-editor-toolbar]');
  if (!addBtn || !toolbar) return;

  const handleFromToolbar = (toolbar.dataset.productHandle || '').toLowerCase();
  const handleFromUrl     = new URLSearchParams(location.search).get('product');
  const productHandle     = (handleFromToolbar || handleFromUrl || '').toLowerCase();

  // -------- helpers --------
  async function fetchProductJson(handle) {
    if (!handle) throw new Error('Missing product handle');
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Could not load product');
    return res.json();
  }

  function selectedColor() {
    const input = document.querySelector('.dh-color-menu input[type="radio"]:checked');
    return (input?.value || 'White').trim();
  }

  function findVariantId(product, color) {
    const want = (color || '').toLowerCase();
    // try exact color match in variant options
    let v = product.variants.find(va => va.options.some(o => (o || '').toLowerCase() === want));
    if (!v) v = product.variants.find(va => va.available) || product.variants[0];
    return v?.id;
  }

  async function addToCart(variantId, quantity, properties) {
    const url  = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    const body = { id: variantId, quantity, properties };
    const res  = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      let msg = 'Add to cart failed';
      try { msg = (await res.json()).description || msg; } catch(_){}
      throw new Error(msg);
    }
    return res.json();
  }

  async function updateCartBubble() {
    const res  = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();
    const count = cart.item_count || 0;

    // Dawn-compatible updates
    document.querySelectorAll('.cart-count-bubble, [data-cart-count-bubble]').forEach(bubble => {
      const text = bubble.querySelector('.text') || bubble.querySelector('[data-cart-count]') || bubble;
      if (text) text.textContent = count;
      bubble.classList.toggle('hidden', count === 0);
    });
  }

  // Optional: open the cart drawer if present
  function openCartDrawerIfAvailable() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    // fallback: briefly pulse the cart icon to show feedback
    const icon = document.querySelector('cart-icon-bubble, a[href$="/cart"]');
    icon?.classList.add('cart-pulse');
    setTimeout(() => icon?.classList.remove('cart-pulse'), 600);
  }

  function getProjectId() {
  const v = localStorage.getItem('dh_project_id');
  return v ? String(v).trim() : null;
}

  async function refreshHeaderCartBubble() {
  // get latest cart (avoid cached responses)
  const res  = await fetch('/cart.js', { credentials:'same-origin', cache:'no-store' });
  const cart = await res.json();
  const count = cart.item_count || 0;

  // find the header cart icon (works on Dawn variants)
  const icon =
    document.querySelector('#cart-icon-bubble') ||               // Dawn anchor id
    document.querySelector('cart-icon-bubble') ||                // custom element (newer Dawn)
    document.querySelector('a.header__icon--cart[href$="/cart"]')||
    document.querySelector('header a[href$="/cart"]');

  if (!icon) return;

  // ensure a bubble exists
  let bubble = icon.querySelector('.cart-count-bubble');
  if (!bubble && count > 0) {
    bubble = document.createElement('div');
    bubble.className = 'cart-count-bubble';
    const span = document.createElement('span');
    span.setAttribute('aria-hidden', 'true');
    bubble.appendChild(span);
    icon.appendChild(bubble);
  }

  // update / show / hide
  if (bubble) {
    const num = bubble.querySelector('[aria-hidden]') || bubble;
    num.textContent = count;
    bubble.classList.toggle('hidden', count === 0);
  }

  // subtle feedback
  icon.classList.add('cart-pulse');
  setTimeout(() => icon.classList.remove('cart-pulse'), 500);
}


  // -------- wire button --------
  addBtn.addEventListener('click', async () => {
    try {
      addBtn.disabled = true;

      const qtyInput = document.querySelector('[name="quantity"]');
      const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10));

      const color = selectedColor();
      const product = await fetchProductJson(productHandle);
      const variantId = findVariantId(product, color);
      if (!variantId) throw new Error('No matching variant');

      const props = {
        'DH Color': color,
        'DH Hash': DH.readTcoHash() || '',
        'DH Template': localStorage.getItem('dh_editor_template_code') || 'product-apparel',
        'DH Project ID': localStorage.getItem('dh_project_id') || ''
      };

      await addToCart(variantId, qty, props);
      await refreshHeaderCartBubble();
      await updateCartBubble();
      openCartDrawerIfAvailable();
    } catch (err) {
      console.error(err);
      alert(err.message || 'Could not add to cart.');
    } finally {
      addBtn.disabled = false;
    }
  });
})();
